<template>
    <div class="absolute inset-0 flex items-center justify-center bg-black/20 z-50">
        <div class="bg-white  rounded-xl shadow-lg text-center w-4/5 h-2/3 flex  flex-col  justify-center items-center">
            <div class="h-1/5  lg:h-2/5 flex flex-col justify-end items-center">
                <!-- <div
                            class="w-12 h-12 border-4 border-[#f01e6b] border-t-transparent rounded-full animate-spin ">
                        </div> -->
                <div class='flex space-x-2 justify-center items-center  h-1/2   w-full'>
                    <div class='h-3 w-3 bg-[#f01e6b] rounded-full animate-bounceFast [animation-delay:-0.3s]'>
                    </div>
                    <div class='h-3 w-3 bg-[#f01e6b] rounded-full animate-bounceFast [animation-delay:-0.15s]'>
                    </div>
                    <div class='h-3 w-3 bg-[#f01e6b] rounded-full animate-bounceFast'></div>
                </div>
            </div>
            <div class="h-4/5 lg:h-3/5 w-full p-5 flex flex-col items-center justify-between">
                <div>
                    <div class="text-sm text-center text-gray-700 font-medium mb-2">{{ $t('sendingNotification') }} </div>
                    <div class="px-3 py-2 rounded-lg bg-slate-200 shadow  text-gray-800  font-medium">{{
                        props.phoneNumber }}</div>

                </div>
                <div class="w-full ">
                    <div class="text-xs mb-2 text-center text-gray-700 font-medium">{{ $t('wrongNumber') }} </div>
                    <div @click="closeModal"
                        class="py-2 rounded-lg bg-[#ee2c73] shadow text-sm text-white font-bold w-1/2 mx-auto hover:cursor-pointer">
                        {{$t('cancel')}}</div>

                </div>
            </div>

        </div>
    </div>
</template>

<script setup>

import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    phoneNumber: String,
});


const emit = defineEmits(['close']);

const closeModal = () => {
    emit('close');
}
</script>